import { jsx as e, jsxs as a } from "react/jsx-runtime";
import { ServiceIcons as t, Text as c, ServiceIcon as m } from "@zapier/design-system";
import { Z as v, s } from "../../ZapBreakdownSkeleton-C9pf86Qq.mjs";
const B = ({ title: o, firstStep: r, lastStep: i, totalStepCount: d, services: n, servicesList: h }) => {
  if (!r || !i || !n)
    return /* @__PURE__ */ e(v, {});
  const l = d > 2, p = d === 3 ? "step" : "steps";
  return /* @__PURE__ */ e("div", { className: s.zapBreakdownWrapper, "data-testid": "zap-breakdown", children: /* @__PURE__ */ a("div", { className: s.zapBreakdownContainer, children: [
    /* @__PURE__ */ a("div", { className: s.title, children: [
      /* @__PURE__ */ e("div", { className: s.servicesArea, children: /* @__PURE__ */ e(t, { "aria-label": `Zap uses ${h.join(", ")}`, maxServices: 3, services: n, size: "medium", hasBorder: !0 }) }),
      /* @__PURE__ */ e(c, { type: "SmallPrint4Multiline", children: o })
    ] }),
    /* @__PURE__ */ e("div", { className: s.detailsLabel, children: /* @__PURE__ */ e(c, { type: "Body4", children: "Zap details:" }) }),
    /* @__PURE__ */ a("div", { className: l ? s.threeOrMoreSteps : s.twoStepsTop, children: [
      /* @__PURE__ */ e("div", { className: s.stepServiceIcon, children: /* @__PURE__ */ e(m, { serviceName: r.serviceName, size: "small", src: r.serviceIcon }) }),
      /* @__PURE__ */ e(c, { className: s.stepLabel, children: `Step 1: ${r.stepLabel} (${r.serviceName})` })
    ] }),
    l && /* @__PURE__ */ a("div", { className: s.hiddenStepsContainer, children: [
      /* @__PURE__ */ e("hr", {}),
      /* @__PURE__ */ e("div", { className: s.hiddenSteps, children: /* @__PURE__ */ a(c, { type: "SmallPrint2", children: [
        "+ ",
        d - 2,
        " ",
        p
      ] }) }),
      /* @__PURE__ */ e("hr", {})
    ] }),
    /* @__PURE__ */ a("div", { className: l ? s.threeOrMoreSteps : s.twoStepsBottom, children: [
      /* @__PURE__ */ e("div", { className: s.stepServiceIcon, children: /* @__PURE__ */ e(m, { serviceName: i.serviceName, size: "small", src: i.serviceIcon }) }),
      /* @__PURE__ */ e(c, { className: s.stepLabel, children: `Step ${d}: ${i.stepLabel} (${i.serviceName})` })
    ] })
  ] }) });
};
export {
  B as ZapBreakdown
};
//# sourceMappingURL=ZapBreakdown.es.js.map
